<template>
  <div>
    <a-select
      v-model="value"
      mode="multiple"
      style="width: 100%"
      placeholder="选择仓库"
      :filter-option="filterOption"
      :max-tag-count="1"
      :allow-clear="true"
      @change="handleChange"
      @blur="handleBlur"
    >
      <a-select-option 
        v-for="opt in option" 
        :key="opt.customerId"
        :value="opt.value">
          {{opt.label}} 
          <span class="tips">({{opt.shipperName}})</span>
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
  export default {
    name:'WareHouseSelect',
    props:{
      option:{
        type:Array,
        default:()=>[]
      },
      selectWare:{
        type:Array,
        default:()=>[]
      }
    },
    data(){
      return{
        value:this.selectWare
      }
    },
    methods:{
      handleChange(){
        this.$emit('change',this.value)
      },
      handleBlur(){
         this.$emit('blur',this.value)
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
    }
  }
</script>

<style lang="less" scoped>
.tips{
  color: #ccc;
  font-size: 12px;
  margin-left: 12px;
}
</style>